const Futures = [
  {
    name: "Free Shipping",
    description: "From All orders over $100",
    icon: "bx bxs-truck",
  },
  {
    name: "Secure Payments",
    description: "100% Protected Payments ",
    icon: "bx bx-credit-card",
  },
  {
    name: "Affordable Prices",
    description: "Get Factory direct price",
    icon: "bx bxs-discount",
  },
  {
    name: "Daily Offers",
    description: "Save up to 25% off",
    icon: "bx bx-gift",
  },
];

export default Futures;
